import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Tickets extends BaseApi {
  constructor() {
    super({ suffix: "support" });
  }

  getTickets(params) {
    return this.httpService.get("tickets", {
      headers,
      params,
    });
  }

  getTicketDetails(params) {
    return this.httpService.get("ticket", {
      headers,
      params,
    });
  }

  getTicketGroups(params) {
    return this.httpService.get("group-ticket", {
      headers,
      params,
    });
  }

  getTicketAttachment(params) {
    return this.httpService.get("attachment-ticket", {
      headers: {
        ...headers,
      },
      responseType: "blob",
      params,
    });
  }

  postTicket(data) {
    let header={...headers,"Content-Type": "multipart/form-data"}
    return this.httpService.post("ticket", data, {
      headers:header,
    });
  }

  postTicketMessage(data) {
    let header={...headers,"Content-Type": "multipart/form-data"}
    return this.httpService.post("ticket/process", data, {
      headers:header,
    });
  }

}
const TicketsService = new Tickets();
export default TicketsService;
